module.exports = __webpack_public_path__ + "img/dp-sy-bm6.13137f65.png";